var render = function render(){var _vm=this,_c=_vm._self._c;return _c('headroom',{attrs:{"disabled":_vm.disabled},on:{"mouseenter":function($event){_vm.disabled = true},"mouseleave":function($event){_vm.disabled = false},"pin":_vm.handlePin}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }